import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { GAM_PRODUCT_SEPERATED_Rs } from '../../../analytics/constants/analytics.constants';
import * as moment from 'moment';

@Component({
	selector: 'app-screenshots-r10',
	templateUrl: './screenshots-r10.component.html',
	styleUrls: ['./screenshots-r10.component.css']
})
export class ScreenshotsR10Component extends BaseWidgetComponent implements OnInit, WidgetCore, OnDestroy {
	public colcount: number;
	public endDate: any;
	public hasData: boolean = false;
	public key: string;
	public screenshotObj: any;
	public screenshotsMatrix: any[][] = [];
	public sectionclass: string;
	public showLoad = true;
	public startDate: any;
	public isR10: boolean = false;
	public filterGamCampaigns: string;
	public isGamSeperated_R: boolean = false;

	private screenShotsData: any[] = [];

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService);
	}

	ngOnInit(): void {
		this.isGamSeperated_R = GAM_PRODUCT_SEPERATED_Rs.includes(this.analyticsDataModel.config.directoryName);
		this.filterGamCampaigns =
			this.isGamSeperated_R && this.analyticsDataModel.getCurrentPath() == 'gam'
				? 'gamOnly'
				: (this.isGamSeperated_R && this.analyticsDataModel.getCurrentPath() == 'display') ||
				  (this.isGamSeperated_R && this.analyticsDataModel.getCurrentPath() == 'preroll')
				? 'nonGamOnly'
				: 'default';
		this.isR10 = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
		super.ngOnInit();
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	requestData(): void {
		this.showLoad = true;
		this.requestSubscription = this.analyticsService
			.processWidgetRequest(this.key, null, null, null, this.filterGamCampaigns)
			.subscribe((res: any) => {
				this.hasData = false;
				this.screenShotsData = [];
				this.screenshotsMatrix = [];
				this.showLoad = false;
				if (res.success && res.data.length > 0) {
					this.hasData = true;
					this.processResponseData(res.data);
				}
				this.startDate = moment(this.analyticsDataModel.startDate).format('MM-DD-YYYY');
				this.endDate = moment(this.analyticsDataModel.endDate).format('MM-DD-YYYY');
			});
	}

	processResponseData(responseData: any): void {
		for (const response of responseData) {
			const obj = {
				completeURL: response.full_url,
				date: response.date,
				imageURL: response.path,
				url: response.url
			};
			if (!this.screenshotObj) {
				this.screenshotObj = obj;
			}
			this.screenShotsData.push(obj);
		}
		this.screenshotsMatrix = UtilityService.listToMatrix(this.screenShotsData, this.colcount);
	}

	getScreenshot(obj: object): void {
		this.screenshotObj = obj;
		var imageContainer = document.querySelector('.img-preview-rect');
		imageContainer.scrollTop = 0;
	}

	getPreviewScreenshot(imageURL: string): void {
		const win = window.open(imageURL, '_blank');
		win.focus();
	}
}
